import React, { useState, useRef } from 'react';
import { useContextMenu } from '../context/ContextMenuContext';
import './List.css';
import { motion } from 'framer-motion';


function ListItem({children, contextMenuIdentifier = '', identifier = 0, gridTemplateColumns = '1fr', memo = '', index = 0, onClick, onDoubleClick, size = 'big', type = 'normal', className = ''}) {
  const { openContextMenu } = useContextMenu();

  const [isPending, setIsPending] = useState(false);
  const lastClickTimeRef = useRef(0);
  const pendingTimerRef = useRef(null);

  const handleContextMenu = (event) => {
    if (contextMenuIdentifier !== '') {
      openContextMenu(event, identifier, contextMenuIdentifier);
    }
  };

  const handleListItemClick = (event) => {
    if (onDoubleClick) {
      const now = Date.now();
      if (now - lastClickTimeRef.current < 400) {
        clearTimeout(pendingTimerRef.current);
        setIsPending(false);
        lastClickTimeRef.current = 0;
        onDoubleClick(event, identifier);
      } else {
        lastClickTimeRef.current = now;
        setIsPending(true);
        clearTimeout(pendingTimerRef.current);
        pendingTimerRef.current = setTimeout(() => {
          setIsPending(false);
          lastClickTimeRef.current = 0;
        }, 600);
      }
    } else if (onClick) {
      onClick(event, identifier);
    }
  }

  const listItemVariants = {
    initial: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { delay: 0.04 * index, duration: 0.25 }
    },
    hover: { cursor: 'pointer' },
    click: {}
  }

  const [longPressTimer, setLongPressTimer] = useState(null);

  const handleTouchMove = () => {
    if (longPressTimer !== null) {
      clearTimeout(longPressTimer);
    }
  };

  const handleTouchStart = (event) => {
    setLongPressTimer(setTimeout(() => {
      handleContextMenu(event);
    }, 150));
  }

  const handleTouchEnd = (event) => {
    if (longPressTimer !== null) {
      clearTimeout(longPressTimer);
    }
  }

  return (
    <motion.div
      className={`listContainer ${size} ${type} ${className} ${isPending ? 'pendingClick' : ''}`}
      onContextMenu={handleContextMenu}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      style={{gridTemplateColumns: `${gridTemplateColumns}`}}
      onClick={handleListItemClick}
      variants={listItemVariants}
      initial="initial"
      animate="visible"
      whileHover="hover"
      whileTap="click"
    >
      {children}
    </motion.div >
  )
}

export default ListItem
